import { render, staticRenderFns } from "./ServiceTypeInfoView.vue?vue&type=template&id=d6060b8a&scoped=true"
import script from "./ServiceTypeInfoView.vue?vue&type=script&lang=js"
export * from "./ServiceTypeInfoView.vue?vue&type=script&lang=js"
import style0 from "./ServiceTypeInfoView.vue?vue&type=style&index=0&id=d6060b8a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6060b8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6060b8a')) {
      api.createRecord('d6060b8a', component.options)
    } else {
      api.reload('d6060b8a', component.options)
    }
    module.hot.accept("./ServiceTypeInfoView.vue?vue&type=template&id=d6060b8a&scoped=true", function () {
      api.rerender('d6060b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/billingHistory/components/ServiceTypeInfoView.vue"
export default component.exports